import React, { PureComponent } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import withNotify from '../common/withNotify';

const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

class Notify extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.notificationSystem = {};
  }

  NotificationMessage = ({ message, type }) => {
    this.setState({ open: true });
    this.notificationSystem = {
      type,
      autoDismiss: 5,
      message,
    };
  };

  handleToClose = () => {
    this.setState({ open: false });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { notifyValue } = nextProps;
    this.NotificationMessage(notifyValue);
  }

  render() {
    return (
      <div>
        <Snackbar
          message={this.notificationSystem.uid}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'bottom',
          }}
          open={this.state.open}
          autoHideDuration={5000}
          onClose={this.handleToClose}
        >
          <Alert
            onClose={this.handleToClose}
            severity={this.notificationSystem.type}
            sx={{ width: '100%' }}
          >
            {this.notificationSystem.message}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

export default withNotify(Notify);
